const helpers = require('../commonordermethods/helpers');

module.exports = function({ items = [], locale, handleError }){

  const output = [];

  handleError = (handleError || (() => {}));

  /*
    if no locale is given 
    register error and return no charges
  */

  if(!locale){

    return output;
  }

  if (locale.private) {

    // NOTE - for now we use this only for testing new locales...
    // let addedCharge = getAddedChargeDefinition({ code: 1 })

    // output.push(addedCharge)

  }
  
  if(locale.home_delivery){

    if(
      typeof locale.home_delivery_zipcodes === 'undefined'
      || typeof locale.home_delivery_charge === 'undefined'
      || typeof locale.home_delivery_free_amount === 'undefined'
    ){

      return handleError(`invalid-homedelivery-locale-params - ${JSON.stringify({
        locale
      })}`);
    }

    const defaultHomeDeliveryCharge = this.getAddedChargeDefinition({ code: 2 });

    let amountTotal;

    try {
  
      // don't include any added charges in this calculation
      amountTotal = helpers.calculateAmountTotalFromItems({ 
        items 
      });

      const chargeAmount = amountTotal < locale.home_delivery_free_amount
        ? locale.home_delivery_charge
        : 0;
      const chargeAmount_ht = Math.ceil(chargeAmount / 1.055);

      output.push({
        code: 2,
        name: 'home-delivery-charge',
        title: 'Frais livraison domicile',
        description: '',
        amount: chargeAmount,
        amount_ht: chargeAmount_ht,
        tva: 5.5
      });

    } 
    catch(error){

      handleError(`homedelivery-charge-error - ${JSON.stringify({
        locale,
        amountTotal,
        items
      })}`);

      output.push(defaultHomeDeliveryCharge);
    }
  }

  return output;
};